import * as React from 'react';
import AlphaRatio from './alphaRatio';

// Backdrop-independent prefix, shared by the original output filter and the
// once-per-capture interactive texture. Keep its filter order identical.
export default function CombinedBlurPaint({
  blur,
  feather,
  paintFrame = false,
}: {
  blur: number;
  feather: number;
  paintFrame?: boolean;
}) {
  return (
    <>
      {paintFrame && feather > 0 && (
        <feGaussianBlur
          in="paint-footprint"
          stdDeviation={feather}
          result="soft-paint-footprint"
        />
      )}
      {feather > 0 && (
        <feGaussianBlur
          in="footprint"
          stdDeviation={feather}
          result="soft-footprint"
        />
      )}
      <feGaussianBlur in="source" stdDeviation={blur} result="blurred-paint" />
      {feather > 0 && (
        <>
          <feGaussianBlur
            in="blurred-paint"
            stdDeviation={feather}
            result="feathered-paint"
          />
          {/* Atop uses the feathered alpha, keeping the original detail in
              opaque interiors and extending edge colour into the fade. */}
          <feComposite
            in="blurred-paint"
            in2="feathered-paint"
            operator="atop"
            result="edge-paint"
          />
        </>
      )}
      <>
        {/* Separate intrinsic paint alpha from frame coverage. Apply the
              same Blur/Softness passes to the hard frame and divide out that
              geometric alpha before the final footprint applies it once.
              Color Dodge(A, 1 - D) computes min(1, A / D) on opaque RGB. */}
        <feGaussianBlur
          in={paintFrame ? 'paint-footprint' : 'footprint'}
          stdDeviation={blur}
          result="blurred-frame"
        />
        <feGaussianBlur
          in="blurred-frame"
          stdDeviation={feather}
          result="paint-frame"
        />
        <AlphaRatio
          numerator={feather > 0 ? 'edge-paint' : 'blurred-paint'}
          denominator="paint-frame"
          result="intrinsic-paint-alpha"
        />
        <feComponentTransfer
          in={feather > 0 ? 'edge-paint' : 'blurred-paint'}
          result="edge-colour"
        >
          <feFuncA type="linear" slope="0" intercept="1" />
        </feComponentTransfer>
        <feComposite
          in="edge-colour"
          in2="intrinsic-paint-alpha"
          operator="in"
          result="blurred"
        />
      </>
    </>
  );
}
